import React from 'react';
import { motion } from 'framer-motion';
import { Globe } from 'lucide-react';
import '../App.css';

const Navbar = ({ language, setLanguage, t }) => {
  return (
    <motion.nav 
      className="navbar glass-panel"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.4, 0, 0.2, 1] }}
    >
      <div className="nav-brand">Medine Uzun</div>
      <div className="nav-links">
        <a href="#experiences" className="nav-link">{t.experiencesTitle}</a>
        <a href="#projects" className="nav-link">{t.projectsTitle}</a>
      </div>
      <div className="lang-switch">
        <Globe size={18} className="lang-icon" />
        <button className={language === 'tr' ? 'active' : ''} onClick={() => setLanguage('tr')}>TR</button>
        <button className={language === 'en' ? 'active' : ''} onClick={() => setLanguage('en')}>EN</button>
      </div>
    </motion.nav>
  );
};

export default Navbar;
